var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.followups, function(followup, index) {
        return _c(
          "div",
          { key: index, staticClass: "row py-3 border-bottom" },
          [
            followup.type_id === 1
              ? _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm._m(0, true),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-10 pl-0 followup-date" }, [
                      _c("p", [_vm._v(_vm._s(followup.date))])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 followup-notes" },
                      [
                        _c("read-more", {
                          staticClass: "show-more",
                          attrs: {
                            "more-str": "Show more",
                            text: followup.notes,
                            "less-str": "Show less",
                            "max-chars": 250
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            followup.type_id === 2
              ? _c(
                  "div",
                  {
                    staticClass: "col-12 pointer",
                    on: {
                      click: function($event) {
                        _vm.showPreview(followup.id)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _vm._m(1, true),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-10 pl-0 followup-date" }, [
                        _c("p", [_vm._v(_vm._s(followup.date))])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 followup-notes" },
                        [
                          _c("read-more", {
                            staticClass: "show-more",
                            attrs: {
                              "more-str": "Show more",
                              text: followup.notes,
                              "less-str": "Show less",
                              "max-chars": 250
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            followup.type_id === 4
              ? _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-2 pr-2" }, [
                      followup.type_id === 4
                        ? _c("div", {
                            staticClass:
                              "mod-icon-follow-up mod-icon-follow-message"
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-10 pl-0 followup-date" }, [
                      _c("p", [_vm._v(_vm._s(followup.date))])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 followup-notes" },
                      [
                        _c("read-more", {
                          staticClass: "show-more",
                          attrs: {
                            "more-str": "Show more",
                            text: followup.notes,
                            "less-str": "Show less",
                            "max-chars": 250
                          }
                        }),
                        _vm._v(" "),
                        _vm._l(followup.media, function(media) {
                          return _c(
                            "p",
                            {
                              key: media.id,
                              staticClass: "w-25 text-media pointer",
                              on: {
                                click: function($event) {
                                  _vm.openFile(media.url)
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "img img-fluid",
                                attrs: { src: media.url, alt: "" }
                              })
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            followup.type_id === 3
              ? _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm._m(2, true),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-10 pl-0 followup-date" }, [
                      _c("p", [_vm._v(_vm._s(followup.date))])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 followup-notes" },
                      [
                        _c("read-more", {
                          staticClass: "show-more",
                          attrs: {
                            "more-str": "Show more",
                            text: followup.notes,
                            "less-str": "Show less",
                            "max-chars": 250
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e()
          ]
        )
      }),
      _vm._v(" "),
      _vm.$_can("leads.follow-ups.store")
        ? _c(
            "div",
            {
              staticClass:
                "row py-2 px-2 mx-0 fixed-bottom border-top position-absolute follows-buttons"
            },
            [
              _c(
                "div",
                {
                  staticClass: "col pt-2 btn btn-secondary tooltip-parent",
                  on: {
                    click: function($event) {
                      _vm.showCallModal = true
                    }
                  }
                },
                [
                  _c("span", {
                    staticClass: "mod-icon-btn-follow mod-icon-btn-incall"
                  }),
                  _c("span", { staticClass: "tooltip-title" }, [
                    _vm._v("Leave in-call notes")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col pt-2 btn btn-secondary tooltip-parent",
                  on: {
                    click: function($event) {
                      _vm.showEmailModal = true
                    }
                  }
                },
                [
                  _c("span", {
                    staticClass: "mod-icon-btn-follow mod-icon-btn-email"
                  }),
                  _c("span", { staticClass: "tooltip-title" }, [
                    _vm._v("Send follow up email")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col pt-2 btn btn-secondary tooltip-parent",
                  class:
                    _vm.lead.company.phone_numbers &&
                    !_vm.lead.company.phone_numbers.find(function(num) {
                      return num.type.id === 1
                    }) &&
                    "disabled",
                  on: {
                    click: function($event) {
                      _vm.lead.company.phone_numbers &&
                      _vm.lead.company.phone_numbers.find(function(num) {
                        return num.type.id === 1
                      })
                        ? (_vm.showSMSModal = true)
                        : ""
                    }
                  }
                },
                [
                  _c("span", {
                    staticClass: "mod-icon-btn-follow mod-icon-btn-message"
                  }),
                  _vm._v(" "),
                  _vm.lead.company.phone_numbers &&
                  !_vm.lead.company.phone_numbers.find(function(num) {
                    return num.type.id === 1
                  })
                    ? _c(
                        "span",
                        { staticClass: "tooltip-title tooltip-title-no-sms" },
                        [
                          _vm._v("Company doesn't have a "),
                          _c("br"),
                          _vm._v("phone number for sending SMS")
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.lead.company.phone_numbers &&
                  _vm.lead.company.phone_numbers.find(function(num) {
                    return num.type.id === 1
                  })
                    ? _c("span", { staticClass: "tooltip-title" }, [
                        _vm._v("Send follow up SMS")
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col pt-2 btn btn-secondary tooltip-parent",
                  on: {
                    click: function($event) {
                      _vm.showVoiceModal = true
                    }
                  }
                },
                [
                  _c("span", {
                    staticClass: "mod-icon-btn-follow mod-icon-btn-voice-call"
                  }),
                  _vm._m(3)
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showCallModal
        ? [
            _c("call", {
              attrs: { lead: _vm.lead },
              on: { close: _vm.closeModal }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.showEmailModal
        ? [
            _c("email", {
              attrs: { lead: _vm.lead },
              on: { close: _vm.closeModal }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.showSMSModal
        ? [
            _c("s-m-s", {
              attrs: { lead: _vm.lead },
              on: { close: _vm.closeModal }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.showVoiceModal
        ? [
            _c("voice", {
              attrs: { lead: _vm.lead },
              on: { close: _vm.closeModal }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.showPreviewEmail
        ? [
            _c("preview-email", {
              attrs: { lead: _vm.lead, "follow-up-id": _vm.followUpId },
              on: { close: _vm.closeModal }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2 pr-2" }, [
      _c("div", { staticClass: "mod-icon-follow-up mod-icon-follow-incall" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2 pr-2" }, [
      _c("div", { staticClass: "mod-icon-follow-up mod-icon-follow-email" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2 pr-2" }, [
      _c("div", {
        staticClass: "mod-icon-follow-up mod-icon-follow-voice-call"
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "tooltip-title tooltip-title-voice" }, [
      _vm._v("Leave voice "),
      _c("br"),
      _vm._v("message notes")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-89be5c90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89be5c90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/leads/LeadsFollowups.vue
// module id = null
// module chunks = 